export const copyToClipboard = (url: string, _anchor?: HTMLElement | null, focusAnchorElement?: boolean) => {
  const anchor = _anchor || document.body;
  setTimeout(() => {
    const prevFocus = document.activeElement as HTMLElement | null;

    const link = Object.assign(document.createElement('input'), {
      value: url,
      style: { opacity: '0' }
    });

    anchor.appendChild(link);
    link.select();
    document.execCommand('copy');
    anchor.removeChild(link);

    if (focusAnchorElement && _anchor) {
      _anchor?.focus();
    } else {
      prevFocus?.focus();
    }
  });
};
